import { render, staticRenderFns } from "./ReportPdfPage.vue?vue&type=template&id=be6534b8&"
import script from "./ReportPdfPage.vue?vue&type=script&lang=js&"
export * from "./ReportPdfPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports